import { Pipe, PipeTransform } from '@angular/core';
import { TimeFormat } from '@app/components/pl-timepicker/pl-timepicker.component';
import { format, getHours, getMinutes } from 'date-fns';

export const MIDNIGHT: string = 'Midnight';
export const NOON: string = 'Midday';

@Pipe({ name: 'calendarViewHourDisplay' })
export class CalendarViewHourDisplayPipe implements PipeTransform {
  public transform(date: Date | undefined, timeFormat: TimeFormat): string {
    if (date) {
      const hours: number = getHours(date);
      if (hours === 0) {
        return MIDNIGHT;
      }

      if (timeFormat === TimeFormat.twentyFourHours) {
        return format(date, 'HH:mm');
      } else if (timeFormat === TimeFormat.amPm) {
        let formatDate: string = 'h';
        if (getMinutes(date) !== 0) {
          formatDate += `:mm`;
        } else if (hours === 12) {
          return NOON;
        }
        formatDate += ` aaa`;

        return format(date, formatDate).toUpperCase();
      }

      throw new Error(`Unknown time format: ${timeFormat}`);
    }

    return '';
  }
}
